import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { LanguageProvider } from './contexts/LanguageContext'
import { CartProvider } from './contexts/CartContext'
import { AuthProvider } from './contexts/AuthContext'
import Header from './components/Header'
import Home from './pages/Home'
import Shop from './pages/Shop'
import ProductDetail from './pages/ProductDetail'
import Cart from './pages/Cart'
import Checkout from './pages/Checkout'
import OrderSuccess from './pages/OrderSuccess'
import ScrollToTop from './components/ScrollToTop'
import MaintenanceGate from './components/MaintenanceGate'
import Auth from './pages/Auth'
import Logout from './pages/Logout'
import Account from './pages/Account'
import DebugAuth from './pages/DebugAuth'
import AliensFromMars from './pages/AliensFromMars'
import AlrichePresentation from './pages/AlrichePresentation'

function App() {
  return (
    <Router>
      <LanguageProvider>
        <CartProvider>
          <AuthProvider>
            <MaintenanceGate>
              <div className="min-h-screen bg-white">
                <Header />
                <ScrollToTop />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/shop/:id" element={<ProductDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order-success" element={<OrderSuccess />} />
                  <Route path="/order-success/:id" element={<OrderSuccess />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/logout" element={<Logout />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/debug-auth" element={<DebugAuth />} />
                  <Route path="/aliens-from-mars" element={<AliensFromMars />} />
                  <Route path="/alriche-presentation" element={<AlrichePresentation />} />
                </Routes>
              </div>
            </MaintenanceGate>
          </AuthProvider>
        </CartProvider>
      </LanguageProvider>
    </Router>
  )
}

export default App


